/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ position: NonNullable<unknown>, name: NonNullable<unknown>, detail: NonNullable<unknown> }} Today_Exercise_OpenInputs */

const en_us2_today_exercise_open = /** @type {(inputs: Today_Exercise_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.position}. ${i?.name}, ${i?.detail}. View exercise`)
};

const pt_br2_today_exercise_open = /** @type {(inputs: Today_Exercise_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.position}. ${i?.name}, ${i?.detail}. Ver exercício`)
};

const es_419_today_exercise_open = /** @type {(inputs: Today_Exercise_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.position}. ${i?.name}, ${i?.detail}. Ver ejercicio`)
};

const pt_pt2_today_exercise_open = /** @type {(inputs: Today_Exercise_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.position}. ${i?.name}, ${i?.detail}. Ver exercício`)
};

const fr_fr2_today_exercise_open = /** @type {(inputs: Today_Exercise_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.position}. ${i?.name}, ${i?.detail}. Voir l'exercice`)
};

const de_de2_today_exercise_open = /** @type {(inputs: Today_Exercise_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.position}. ${i?.name}, ${i?.detail}. Übung ansehen`)
};

const it_it2_today_exercise_open = /** @type {(inputs: Today_Exercise_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.position}. ${i?.name}, ${i?.detail}. Vedi esercizio`)
};

/**
* | output |
* | --- |
* | "{position}. {name}, {detail}. View exercise" |
*
* @param {Today_Exercise_OpenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_exercise_open = /** @type {((inputs: Today_Exercise_OpenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Exercise_OpenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_exercise_open(inputs)
	if (locale === "es-419") return es_419_today_exercise_open(inputs)
	if (locale === "pt-PT") return pt_pt2_today_exercise_open(inputs)
	if (locale === "fr-FR") return fr_fr2_today_exercise_open(inputs)
	if (locale === "de-DE") return de_de2_today_exercise_open(inputs)
	if (locale === "it-IT") return it_it2_today_exercise_open(inputs)
	return en_us2_today_exercise_open(inputs)
});
export { today_exercise_open as "today.exercise_open" }